import { render } from "./ToolbarLink.vue?vue&type=template&id=21c0093c&scoped=true"
import script from "./ToolbarLink.vue?vue&type=script&lang=js"
export * from "./ToolbarLink.vue?vue&type=script&lang=js"

import "./ToolbarLink.vue?vue&type=style&index=0&id=21c0093c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c0093c"]])

export default __exports__